<template>
<div>
  <div class="content">
    <van-cell-group inset class="form-card">
      <div class="section-title">
        <van-icon name="todo-list-o" size="18" color="#4080ff" />
        <span>作业用途</span>
      </div>

      <ChoseVehicleUsageNew
        :options="usageList"
        :modelValue="usageType"
        @update:modelValue="usageType = $event"
        @change="changeVehicleUsage"
      />
    </van-cell-group>  

    <van-form @submit="submitJsy" @failed="failSubmit" ref="formRef">
      <!--蒸洗作业-->
      <div v-if="usageType == '1'" class="addDriver_step_A">
        <van-cell-group inset>
          <div class="upload-jsz-front">
            <div class="addDriver_step_A_1">
              <h2 class="jsz-titile input-title-hq red-required">本人驾驶证正页</h2>
              <div class="upload-jsz-front-box">
                <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="jsz_image" :before-read="beforeRead" :after-read="uploadJszFront" :before-delete="deleteJszFront" @click-preview="destroyDriver" @close-preview="showDriver(1)"></van-uploader>
              </div>
            </div>


            <div class="jsz-front-info-box">
              <van-field v-model="jsz_name" name="jsz_name" required :value="jsz_name" :rules="[{ validator:validatorJszName, message: '请填写姓名' }]" placeholder="请输入" @input="refreshDriver">
                <template #label>
                  <span class="input-left-label-hq">姓名</span>
                </template>
              </van-field>
              <van-field v-model="zjcx" name="zjcx" required :value="zjcx" :rules="[{ validator:validatorZjcx, message: '请填写准驾车型' }]" placeholder="请输入" @input="refreshDriver">
                <template #label>
                  <span class="input-left-label-hq">准驾车型</span>
                </template>
              </van-field>
              <van-field v-model="jsz_no" name="jsz_no" required :value="jsz_no" :rules="[{ validator:validatorJszNo, message: '请填写身份证' }]" placeholder="请输入" @input="refreshDriver">
                <template #label>
                  <span class="input-left-label-hq">身份证</span>
                </template>
              </van-field>
              <van-field v-model="telephone" name="telephone" required type="tel" :value="telephone" :rules="[{ validator:validatorJszTel, message: '请填写联系电话' }]" placeholder="请输入" @input="refreshDriver">
                <template #label>
                  <span class="input-left-label-hq">联系电话</span>
                </template>
              </van-field>
              <ChoseTime :timeVmodel="jszYxq" :timeName="jszYxq" :timeLabel="jszYxqLabel" @getYxq="getJszYxq" :timeValue="jsz_yx_time" @close="showDriver(2)" />
            </div>

          </div>
        </van-cell-group>  
      </div>

      <!--蒸洗+装卸作业-->
      <div v-if="usageType == '2'" class="addDriver_step_B">
        <van-cell-group inset>
          <div class="upload-jsz-front">
            <div class="addDriver_step_B_1">
              <h2 class="jsz-titile input-title-hq red-required">本人驾驶证正页</h2>
              <div class="upload-jsz-front-box">
                <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="jsz_image" :before-read="beforeRead" :after-read="uploadJszFront" :before-delete="deleteJszFront" @click-preview="destroyDriver" @close-preview="showDriver(1)"></van-uploader>
              </div>

              <h2 class="jsz-titile input-title-hq red-required">本人驾驶证副页</h2>
              <div class="upload-jsz-front-box last-bottom">
                <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="jsz_fy_image" :before-read="beforeRead" :after-read="uploadJszFy" :before-delete="deleteJszFy" @click-preview="destroyDriver" @close-preview="showDriver(1)"></van-uploader>
              </div>
            </div>
            <div class="jsz-front-info-box addDriver_step_B_2">
              <van-field v-model="jsz_name" name="jsz_name" required :value="jsz_name" :rules="[{ validator:validatorJszName, message: '请填写姓名' }]" placeholder="请输入" @input="refreshDriver">
                <template #label>
                  <span class="input-left-label-hq">姓名</span>
                </template>
              </van-field>
              <van-field v-model="zjcx" name="zjcx" required :value="zjcx" :rules="[{ validator:validatorZjcx, message: '请填写准驾车型' }]" placeholder="请输入" @input="refreshDriver">
                <template #label>
                  <span class="input-left-label-hq">准驾车型</span>
                </template>
              </van-field>
              <van-field v-model="jsz_no" name="jsz_no" required :value="jsz_no" :rules="[{ validator:validatorJszNo, message: '请填写身份证' }]" placeholder="请输入" @input="refreshDriver">
                <template #label>
                  <span class="input-left-label-hq">身份证</span>
                </template>
              </van-field>
              <van-field v-model="telephone" name="telephone" required type="tel" :value="telephone" :rules="[{ validator:validatorJszTel, message: '请填写联系电话' }]" placeholder="请输入" @input="refreshDriver">
                <template #label>
                  <span class="input-left-label-hq">联系电话</span>
                </template>
              </van-field>
              <ChoseTime :timeVmodel="jszYxq" :timeName="jszYxq" :timeLabel="jszYxqLabel" @getYxq="getJszYxq" :timeValue="jsz_yx_time" @close="showDriver(2)" />
            </div>
          </div>
        </van-cell-group>
        <div class="cyzgz">
          <van-cell-group inset>
            <div class="upload-cyzgz-front">
              <div class="addDriver_step_B_3">
                <h2 class="jsz-titile input-title-hq red-required">从业资格证正面</h2>
                <div class="upload-cyzgz-front-box">
                  <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="cyzgz_image" :before-read="beforeRead" :after-read="uploadCyzgzFront" :before-delete="deleteCyzgzFront" @click-preview="destroyDriver" @close-preview="showDriver(3)"></van-uploader>
                </div>

                <h2 class="jsz-titile input-title-hq">从业资格证反面</h2>
                <div class="upload-cyzgz-front-box">
                  <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="cyzgz_fm_image" :before-read="beforeRead" :after-read="uploadCyzgzFm" :before-delete="deleteCyzgzFm" @click-preview="destroyDriver" @close-preview="showDriver(3)"></van-uploader>
                </div>
              </div>
              <div class="addDriver_step_B_4">
                <div class="jsz-cyzgz-info-box">
                  <ChoseTime :timeVmodel="cyzgYxq" :timeName="cyzgYxq" :timeLabel="cyzgYxqLabel" @getYxq="getCyzgYxq" :timeValue="cyzgz_yx_time" @close="showDriver(4)" />
                </div>
              </div>
            </div>
          </van-cell-group>
        </div>
      </div>
      
      <div style="margin: 1rem;" v-if="usageType">
        <van-button round block type="info" native-type="submit" class="addBtn" @loading="loadingBtn" color="#4080ff">
          保存
        </van-button>
      </div>

    </van-form>
  </div>
  <Tabbar></Tabbar>
</div>
</template>

<script>
import api from "@/fetch/api"
import {
  Toast,
  Dialog
} from 'vant';
import ChoseTime from "../Public/choseTime.vue"
import Compressor from 'compressorjs';
import Tabbar from '../Public/tabbarTpl.vue'
import ChoseVehicleUsageNew from '../Public/choseVehicleUsageNew.vue';
import autoSubmitBeian from '@/mixins/autoSubmitBeian';
import store from '@/store';
export default {
  components: {
    ChoseTime,
    Tabbar,
    ChoseVehicleUsageNew
  },
  mixins: [autoSubmitBeian],
  data() {
    return {
      jsz_zm: '',
      cyzgz_zm: '',
      zjcx: '',
      jsz_image: [],
      cyzgz_image: [],
      jsz_fy_image: [],
      cyzgz_fm_image: [],
      jsz_name: "",
      jsz_no: "",
      telephone: "",
      jsz_yx_time: "",
      loadingBtn: false,
      jsz_url: "",
      jsz_fy_url: "",
      cyzgz_url: "",
      cyzgz_fm_url: "",
      cyzgz_yx_time: "",
      jszYxq: "jsz_yx_time",
      jszYxqLabel: "驾驶证截至日期",
      cyzgYxq: "cyzgz_yx_time",
      cyzgYxqLabel: "从业资格证截止日期",
      // 车辆用途列表
      usageList: [],
      // 车辆用途类型
      usageType: '',
      timeRequire: true,
      // 动态步骤
      steps: [] // 初始为空，动态生成
    };
  },
  created() {
    document.title = "添加驾驶员信息";
    this.getUsage();
    // 初始化引导步骤
    this.steps.push({
      element: '.form-card',
      popover: {
        title: '请选择作业用途',
        // description: '描述文本',
        showButtons: []
      },
    })
  },
  mounted() {
    // 开始引导
    this.$driverObj.setSteps(this.steps);
    store.state.isFirstTime && this.$driverObj.drive();
  },
  destroyed() {
    this.$driverObj.destroy();
  },
  methods: {
    //蒸洗，蒸洗+装卸货切换
    changeVehicleUsage(val) {
      this.usageType = val
      // 分支判断示例
      if (val === '1') {
        this.steps.splice(1, this.steps.length - 1,...this.getPathA())
      } else if (val === '2') {
        this.steps.splice(1, this.steps.length - 1,...this.getPathB())
      }
      this.$nextTick(() => {
        this.$driverObj.moveNext(); // 继续执行
      })
      if(this.usageType == '1') {
        this.timeRequire = false
      } else {
        this.timeRequire = true;
      }
      // this.timeRequire = val !== '1';
    },

    // 仅蒸洗分支
    getPathA() {
      return [
        {
          element: '.addDriver_step_A_1',
          popover: {
            title: '填写信息',
            description: '上传驾驶证照片',
            onNextClick: () => {
              this.jsz_url && this.$driverObj.moveNext();
            },
          }
        },
        {
          element: '.addDriver_step_A .jsz-front-info-box',
          popover: {
            title: '填写信息',
            description: '确认信息是否正确',
            onNextClick: () => {
              this.$refs.formRef.validate().then(() => {
                this.$driverObj.moveNext();
              }).catch(() => {
                this.$driverObj.refresh();
              })
            },
          }
        },
        {
          element: '.addBtn',
          popover: {
            title: '点击保存',
            description: '完成驾驶员信息录入',
            showButtons: ['previous']
          }
        },
      ];
    },
    // 仅蒸洗+装卸分支
    getPathB() {
      return [
        {
          element: '.addDriver_step_B_1',
          popover: {
            title: '填写信息',
            description: '上传驾驶证照片',
            onNextClick: () => {
              (this.jsz_url && this.jsz_fy_url) && this.$driverObj.moveNext();
            },
          }
        },
        {
          element: '.addDriver_step_B_2',
          popover: {
            title: '填写信息',
            description: '确认信息是否正确',
            onNextClick: () => {
              this.$refs.formRef.validate(['jsz_name', 'zjcx', 'jsz_no', 'telephone', 'jszYxq']).then(() => {
                this.$driverObj.moveNext();
              }).catch(() => {
                this.$driverObj.refresh();
              })
            },
          }
        },
        {
          element: '.addDriver_step_B_3',
          popover: {
            title: '填写信息',
            description: '上传从业资格证照片',
            onNextClick: () => {
              (this.cyzgz_url) && this.$driverObj.moveNext();
            },
          }
        },
        {
          element: '.addDriver_step_B_4',
          popover: {
            title: '填写信息',
            description: '确认信息是否正确',
            onNextClick: () => {
              this.$refs.formRef.validate(['cyzgYxq']).then(() => {
                this.$driverObj.moveNext();
              }).catch(() => {
                this.$driverObj.refresh();
              })
            },
          }
        },
        {
          element: '.addBtn',
          popover: {
            title: '点击保存',
            description: '完成驾驶员信息录入',
            showButtons: ['previous'] } },
      ];
    },

    refreshDriver() {
      this.$driverObj.refresh();
    },

    destroyDriver() {
      this.$driverObj.destroy();
    },

    // 继续指定步骤的引导
    showDriver(step) {
      this.$driverObj.drive(step);
    },

    // 获取车辆用途
    async getUsage() {
      try {
        const res = JSON.parse(await api.getTypeList('vehicleUsage'));
        if (res.success) {
          this.usageList = res.obj.filter((item) => {
            return item.typecode !== '';
          });
        } else {
          Toast.fail(res.message);
        }
      } catch (e) {
        console.log('获取车辆用途失败', e);
      }
    },
    beforeRead(file) {
      let quality = 0.6;
      if (file.size < 4 * 1024 * 1024) {
        quality = 0.9;
      } else if (file.size >= 4 * 1024 * 1024 && file.size < 8 * 1024 * 1024) {
        quality = 0.8;
      } else {
        quality = 0.6;
      }

      return new Promise((resolve) => {
        // compressorjs 默认开启 checkOrientation 选项
        // 会将图片修正为正确方向
        new Compressor(file, {
          quality: quality,
          success(result) {
            let newfile = new File([result], file.name, {
              type: file.type
            })
            resolve(newfile)
          },
          error(err) {
            console.log('图片压缩失败---->>>>>', err)
          }
        })

      });

    },
    onOversize(file) {
      console.log(file);
      Toast('文件大小不能超过 10Mb');
    },
    validatorJszName(val) {
      if (!val) {
        Toast.fail('请填写姓名');
        return false;
      }
      return val;
    },
    validatorZjcx(val) {
      if (!val) {
        Toast.fail('请填写准驾车型');
        return false;
      }
      return val;
    },
    validatorJszNo(val) {
      if (!val) {
        Toast.fail('请填写身份证');
        return false;
      }
      return val;
    },
    validatorJszTel(val) {
      if (!val) {
        Toast.fail('请填写联系电话');
        return false;
      }
      return val;
    },
    isCardNo(card) {
      //身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
      var reg = /(^\d{17}(\d|X|x)$)/;
      if (reg.test(card) === false) {
        return false;
      }
      return true;
    },
    // 提交表单失败
    failSubmit() {
      this.$driverObj.destroy()
    },
    //提交表单
    submitJsy(values) {
      store.state.isFirstTime && this.$driverObj.destroy()
      if (this.usageType == '1') {
        let that = this;
        let openid = that.$store.state.wx_info.openid;
        let jiashizhengurl = that.jsz_url ? that.jsz_url : "";
        if (!jiashizhengurl) {
          Toast.fail('请上传驾驶证正页');
          return false;
        }

        let shenfenzheng = values.jsz_no ? values.jsz_no : "";
        if (!this.isCardNo(shenfenzheng)) {
          Toast.fail('身份证号码格式不正确');
          return false;
        }
        that.$data.loadingBtn = true;
        let formData = JSON.stringify({
          congyezigeurl: '',
          congyezigefmurl: '',
          congyezigeyxq: '',
          jiashizhengurl: jiashizhengurl,
          jieshizhengfburl: '',
          jiashizhengyxq: that.jsz_yx_time ? that.jsz_yx_time : "",
          name: values.jsz_name ? values.jsz_name : "",
          openid: openid,
          shenfenzheng: shenfenzheng,
          telphone: values.telephone ? values.telephone : "",
          zjcx: values.zjcx ? values.zjcx : "",
          vehicleUsage: that.usageType,
        });

        api.beianJsz(formData).then(function(res) {
          var resData = JSON.parse(res);
          if (resData.respCode == "0") {
            Dialog.alert({
              message: '信息保存成功',
            }).then(() => {
              that.$router.push({
                name: 'driverList'
              })
            });
          } else {
            Dialog.alert({
              message: resData.message,
            }).then(() => {
              // on confirm
            });
          }
        }).catch(function() {
          that.$data.loadingBtn = false;
          Toast.fail('连接失败，请刷新页面');

        });

      } else {
        let that = this;
        let openid = that.$store.state.wx_info.openid;
        let jiashizhengurl = that.jsz_url ? that.jsz_url : "";
        let jieshizhengfburl = that.jsz_fy_url ? that.jsz_fy_url : "";
        let congyezigeurl = that.cyzgz_url ? that.cyzgz_url : "";
        let congyezigefmurl = that.cyzgz_fm_url ? that.cyzgz_fm_url : "";
        if (!jiashizhengurl) {
          Toast.fail('请上传驾驶证正页');
          return false;
        }
        if (!jieshizhengfburl) {
          Toast.fail('请上传驾驶证副页');
          return false;
        }
        if (!congyezigeurl) {
          Toast.fail('请上传从业资格证');
          return false;
        }

        let shenfenzheng = values.jsz_no ? values.jsz_no : "";
        if (!this.isCardNo(shenfenzheng)) {
          Toast.fail('身份证号码格式不正确');
          return false;
        }

        that.$data.loadingBtn = true;
        let formData = JSON.stringify({
          congyezigeurl: congyezigeurl,
          congyezigefmurl: congyezigefmurl,
          congyezigeyxq: that.cyzgz_yx_time ? that.cyzgz_yx_time : "",
          jiashizhengurl: jiashizhengurl,
          jieshizhengfburl: jieshizhengfburl,
          jiashizhengyxq: that.jsz_yx_time ? that.jsz_yx_time : "",
          name: values.jsz_name ? values.jsz_name : "",
          openid: openid,
          shenfenzheng: shenfenzheng,
          telphone: values.telephone ? values.telephone : "",
          zjcx: values.zjcx ? values.zjcx : "",
          vehicleUsage: that.usageType,
        });

        api.beianJsz(formData).then(function(res) {
          var resData = JSON.parse(res);
          if (resData.respCode == "0") {
            var newId = '';
            if (resData.data) {
              if (resData.data.id) {
                newId = resData.data.id;
              } else if (typeof resData.data === 'string' || typeof resData.data === 'number') {
                newId = resData.data;
              }
            }
            if (that.usageType == '2' && newId) {
              that.autoSubmitBeian('driver', newId, 'driverList');
            } else {
              Dialog.alert({
                message: '信息保存成功',
              }).then(() => {
                that.$router.push({
                  name: 'driverList'
                })
              });
            }
          } else {
            Dialog.alert({
              message: resData.message,
            }).then(() => {
              // on confirm
            });
          }
        }).catch(function() {
          that.$data.loadingBtn = false;
          Toast.fail('连接失败，请刷新页面');

        });
      }

    },
    getJszYxq(xszYxq) {
      this.jsz_yx_time = xszYxq
      store.state.isFirstTime && this.showDriver(2)
    },
    getCyzgYxq(xszYxq) {
      this.cyzgz_yx_time = xszYxq
      store.state.isFirstTime && this.showDriver(4)
    },
    //上传驾驶证正页
    uploadJszFront(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      api.uploadJszFront(formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.$data.jsz_image = imageData.jiashizhengurl ? [{
            url: weburl + '/' + imageData.jiashizhengurl
          }] : that.$data.jsz_image;
          that.$data.jsz_url = imageData.jiashizhengurl ? imageData.jiashizhengurl : that.$data.jsz_url;
          that.$data.jsz_name = imageData.name ? imageData.name : that.$data.jsz_name;
          that.$data.jsz_no = imageData.shenfenzheng ? imageData.shenfenzheng : that.$data.jsz_no;
          that.$data.telephone = imageData.telephone ? imageData.telephone : that.$data.telephone;
          that.$data.jsz_yx_time = imageData.jiashizhengyxq ? imageData.jiashizhengyxq : that.$data.jsz_yx_time;
          that.$data.zjcx = imageData.zjcx ? imageData.zjcx : that.$data.zjcx;
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function() {
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });

    },
    //上传驾驶证副页
    uploadJszFy(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      api.uploadJszFront(formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.$data.jsz_fy_image = imageData.jiashizhengurl ? [{
            url: weburl + '/' + imageData.jiashizhengurl
          }] : [];
          that.$data.jsz_fy_url = imageData.jiashizhengurl ? imageData.jiashizhengurl : "";
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function() {
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },
    //上传从业资格证
    uploadCyzgzFront(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      api.uploadCyzgz(formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.cyzgz_image = imageData.congyezigeurl ? [{
            url: weburl + '/' + imageData.congyezigeurl
          }] : [];
          that.cyzgz_url = imageData.congyezigeurl ? imageData.congyezigeurl : "";
          if(imageData.congyezigeyxq) that.cyzgz_yx_time = imageData.congyezigeyxq;
          if(that.jsz_name != imageData.name && that.jsz_name)
          {
            Toast.fail("证件姓名与登记姓名不符合");
          }
        }
        else if(resData.respCode == "-1" && resData.data != null)
        {
          Toast.fail(resData.message);
          var imageData2 = resData.data;
          that.cyzgz_image = [{
            url: weburl + '/' + imageData2.congyezigeurl
          }];
          that.cyzgz_url = imageData2.congyezigeurl ? imageData2.congyezigeurl : "";
        }
        else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function() {
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });

    },
    //从业资格证反页
    uploadCyzgzFm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      api.uploadCyzgzFm(formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.cyzgz_fm_image = imageData.congyezigefmurl ? [{
            url: weburl + '/' + imageData.congyezigefmurl
          }] : [];
          that.cyzgz_fm_url = imageData.congyezigefmurl ? imageData.congyezigefmurl : "";
          if(imageData.congyezigeyxq) that.cyzgz_yx_time = imageData.congyezigeyxq;
          // if(that.jsz_name != imageData.name && that.jsz_name)
          // {
          //   Toast.fail("证件姓名与登记姓名不符合");
          // }
        }
        else if(resData.respCode == "-1" && resData.data != null)
        {
          Toast.fail(resData.message);
          var imageData2 = resData.data;
          that.cyzgz_image = [{
            url: weburl + '/' + imageData2.congyezigeurl
          }];
          that.cyzgz_url = imageData2.congyezigeurl ? imageData2.congyezigeurl : "";
        } 
        else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function() {
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },
    deleteJszFront() {
      this.$data.jsz_image = [];
      this.$data.jsz_url = "";
    },
    deleteJszFy() {
      this.$data.jsz_fy_image = [];
      this.$data.jsz_fy_url = "";
    },
    deleteCyzgzFront() {
      this.$data.cyzgz_image = [];
      this.$data.cyzgz_url = "";
    },
    deleteCyzgzFm() {
      this.$data.cyzgz_fm_image = [];
      this.$data.cyzgz_fm_url = "";
    },
  }
};
</script>

<style lang="scss" scoped>
.content {
    margin: 1rem 0 3.75rem;
    padding-bottom: env(safe-area-inset-bottom);
}
.red-required {
  position: relative;
  padding-left: 0.75rem;

  &::before {
    position: absolute;
    left: 0;
    color: #ee0a24;
    font-size: 15px;
    content: '*';
  }
}
.upload-jsz-front {
    //border-top: 1px solid #ececec;
    padding-top: 0.625rem;
    background: #fff;
    .jsz-titile {
        padding: 0.675rem 1rem;
        color: #646566;
    }
    .upload-jsz-front-box {
        margin: 0 1rem;
    }
    .last-bottom {
        padding-bottom: 0.625rem;
        border-bottom: 1px solid #ebedf0;
    }
}

.cyzgz {
    margin-top: 1rem;
}
.upload-cyzgz-front {
    margin-top: 0.625rem;
    //border-top: 1px solid #ececec;
    background: #fff;
    .jsz-titile {
        padding: 0.675rem 1rem;
    }
    .upload-cyzgz-front-box {
        margin-left: 1rem;
    }
}

.form-card {
  margin-bottom: 1rem;
  border-radius: 0.5rem;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.section-title {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  background: #f7f8fa;
  border-bottom: 1px solid #ebedf0;

  span {
    margin-left: 0.5rem;
    font-size: 15px;
    font-weight: 500;
    color: #323233;
  }
}
</style>
